/* istanbul ignore file */
export const MAP_FIELD_POINT_MODAL_MESSAGE_CONSTANTS = {
    CREATE_COORDINATES_PROMPT: 'Click the map to add your point. When you’re finished, select “done” and your coordinates will populate on the right.',
    EDIT_COORDINATES_PROMPT: 'Click and drag the point or click the map to move the point to the desired location. When you’re finished, select “done” and your coordinates will update on the right.'
};
